import { c as _c } from "react/compiler-runtime";
import { css, cx } from "~/generated/styled-system/css";
import { section as sectionRecipe } from "~/generated/styled-system/recipes";

// Mobile: full width with a 16px gutter. From `@/3xl` every section's content spans
// the same 80% of the band so edges line up page-wide, holding at the 2xl breakpoint
// width (1536px) on very wide screens.
const containerClass = css({
  position: "relative",
  width: "full",
  maxWidth: "breakpoint-2xl",
  marginInline: "auto",
  paddingInline: "4",
  "@/3xl": {
    width: "80%",
    paddingInline: "0"
  }
});
/**
 * Full-bleed content band: a `<section>` that sets the palette for its contents
 * (recipe: `tone` palette, `variant` ground, `size` vertical rhythm) wrapping a
 * centered content container.
 */
export function Section(t0) {
  const $ = _c(20);
  let children;
  let className;
  let id;
  let rest;
  let size;
  let tone;
  let variant;
  if ($[0] !== t0) {
    ({
      tone,
      variant,
      size,
      id,
      className,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = id;
    $[4] = rest;
    $[5] = size;
    $[6] = tone;
    $[7] = variant;
  } else {
    children = $[1];
    className = $[2];
    id = $[3];
    rest = $[4];
    size = $[5];
    tone = $[6];
    variant = $[7];
  }
  let t1;
  if ($[8] !== className || $[9] !== size || $[10] !== tone || $[11] !== variant) {
    t1 = cx(sectionRecipe({
      tone,
      variant,
      size
    }), className);
    $[8] = className;
    $[9] = size;
    $[10] = tone;
    $[11] = variant;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== children) {
    t2 = <div className={containerClass}>{children}</div>;
    $[13] = children;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== id || $[16] !== rest || $[17] !== t1 || $[18] !== t2) {
    t3 = <section id={id} className={t1} {...rest}>{t2}</section>;
    $[15] = id;
    $[16] = rest;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  return t3;
}